<script lang="ts">
import { masterService } from '@/services/serviceProvider';

export default {
    props: {
        modelValue: {
            type: String,
            default: undefined,
        },
        viewMode: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    components: {
    },
    data() {
        return {
            countryOptions: [] as any[],
            rules: {
                required: (message: any) => {
                    return (v: any) => !!v || message;
                },
            },
        };
    },
    mounted() {
        this.loadCountryOptions();
    },
    computed: {
        selectedCountry: {
            get() {
                return this.modelValue;
            },
            set(newValue: string) {
                this.$emit('update:modelValue', newValue);
            }
        }
    },
    watch: {
        '$i18n.locale': {
            handler() {
                this.loadCountryOptions(); // Update when locale changes
            },
            immediate: true,
        },
    },
    methods: {
        loadCountryOptions() {
            this.countryOptions = masterService.getCountryOptions(this.$i18n.locale)
        },
    }
};
</script>

<template>
    <div>
        <v-autocomplete v-model="selectedCountry" class="hide-float-label" variant="outlined"
            v-bind:placeholder="$t('t-please-select')" hide-details="auto" :items="countryOptions"
            item-value="code" item-title="name" :clearable="false" density="comfortable" :readonly="viewMode"
            :rules="viewMode ? [] : [rules.required(`${$t('t-please-select')}${$t('t-user-nationality')}`)]">
        </v-autocomplete>
    </div>
</template>